module.exports = __webpack_public_path__ + "media/images/img_service_step_4-99f9367a5690b3363a0b64b8d4eb0678.png";